// Soft UI Dashboard PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Custom component
import EndpointManagementForm from "./components/EndpointManagementForm";

// @mui components
import SoftBox from "components/SoftBox";

function NewEPMLicense() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <EndpointManagementForm />
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewEPMLicense;